export const SEND_PAYMENT_LINK = 'SEND_PAYMENT_LINK';
export const REDUCE_PAYMENT_EMAIL = 'REDUCE_PAYMENT_EMAIL';
export const GET_PAYMENT_EMAIL = 'GET_PAYMENT_EMAIL';
export const GET_PAYMENT_OPTION = 'GET_PAYMENT_OPTION';
export const SET_PAYMENT_OPTION = 'SET_PAYMENT_OPTION';
export const REDUCE_PAYMENT_OPTION = 'REDUCE_PAYMENT_OPTION';
export const REDUCE_PAYMENT_OPTION_ELEMENT = 'REDUCE_PAYMENT_OPTION_ELEMENT';
export const INITIATE_PAYMENT_INTENT = 'INITIATE_PAYMENT_INTENT';
export const CONFIRM_CREDIT_CARD_PAYMENT = 'CONFIRM_CREDIT_CARD_PAYMENT';
